import { useMutation, useQueryClient } from 'react-query';
import { IPostCopyCloneHistory } from 'types';
import { copyCloneHistoryRequest, queryKeys } from 'utils';

export const usePostCopyCloneHistory = (estimateId: string) => {
  const queryClient = useQueryClient();
  const queryKey = queryKeys({ estimateId }).details.copyCloneHistories;

  const {
    mutate: postCopyCloneHistory,
    isLoading: postCopyCloneHistoryLoading,
    error: postCopyCloneHistoryError,
    data: postCopyCloneHistoryRes,
  } = useMutation(
    (newCopyCloneHistory: IPostCopyCloneHistory[]) =>
      copyCloneHistoryRequest({
        method: 'POST',
        data: newCopyCloneHistory,
      }),
    {
      onMutate: async (newCopyCloneHistory: IPostCopyCloneHistory[]) => {
        await queryClient.cancelQueries(queryKey);
        const prevCopyCloneHistories =
          queryClient.getQueryData<IPostCopyCloneHistory[]>(queryKey) || [];
        const newCopyCloneHistories = [
          ...prevCopyCloneHistories,
          ...newCopyCloneHistory,
        ];
        queryClient.setQueryData(queryKey, newCopyCloneHistories);
        return { prevCopyCloneHistories };
      },
      onError: async (err, _, context) => {
        console.log(err);
        await queryClient.cancelQueries(queryKey);
        queryClient.setQueryData(queryKey, context?.prevCopyCloneHistories);
      },
      onSettled: () => {
        queryClient.invalidateQueries(queryKey);
      },
    }
  );

  return {
    postCopyCloneHistory,
    postCopyCloneHistoryLoading,
    postCopyCloneHistoryError,
    postCopyCloneHistoryRes,
  };
};
